<template>
  <div>
    <Breadcrumbs main="fleet" title="New car" />

    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header"><h5>Add new car into a fleet</h5></div>
            <form class="form theme-form" @submit.prevent>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Car registration plate</label>
                      <b-form-input
                        type="text"
                        placeholder="Ex. KR7VC21"
                        v-model="formData.regPlate"
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Car owner</label>
                      <b-form-input
                        type="text"
                        placeholder="Ex. BNP Paribas Leasing"
                        v-model="formData.owner"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Make</label>
                      <b-form-input
                        type="text"
                        placeholder="ex. Toyota"
                        v-model="formData.model"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Model</label>
                      <b-form-input
                        type="text"
                        placeholder="ex. Yaris"
                        v-model="formData.make"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Insurance company</label>
                      <b-form-input
                        type="text"
                        placeholder="ex. TUW S.A"
                        v-model="formData.insuranceCompany"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Insurance number</label>
                      <b-form-input
                        type="text"
                        placeholder="ex. PL107/214/12331"
                        v-model="formData.insuranceNumber"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Vin number</label>
                      <b-form-input
                        type="text"
                        placeholder="ex. PL107/214/12331"
                        v-model="formData.vin"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Engine size</label>
                      <b-form-input
                        type="number"
                        placeholder="1799"
                        v-model="formData.engineSize"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Current mileage</label>
                      <b-form-input
                        type="number"
                        placeholder="ex. 1233"
                        v-model="formData.mileage"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Color</label>
                      <b-form-select
                        :options="colors"
                        v-model="formData.color"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Inurance expiry</label>
                      <b-form-input
                        type="date"
                        placeholder="Choose date"
                        v-model="formData.insuranceExpiry"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Maintance date</label>
                      <b-form-input
                        type="date"
                        placeholder="Choose date"
                        v-model="formData.maitenanceDate"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                      <label>Registration document number</label>
                      <b-form-input
                        type="text"
                        placeholder="BA/BW52114"
                        v-model="formData.regDocNumber"
                        required
                      ></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Driving system</label>
                      <b-form-select
                        placeholder="Kowalski"
                        v-model="formData.currentSystem"
                        :options="options"
                      ></b-form-select>
                    </div>
                  </div>
                </div>
                <div class="media">
                  <label
                    class="col-form-label m-r-10"
                    v-b-tooltip.hover
                    title="By selecting this option, the car will not be available
                      for rent until the availability option is deselected
                      again."
                    id="usertip"
                    >Not available <b-badge variant="primary" >Info</b-badge></label
                  >

                  <div class="media-body text-right">
                    <label class="switch">
                      <input type="checkbox" v-model="formData.notAvailable" /><span
                        class="switch-state"
                      ></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <b-button
                  type="submit"
                  @click="addNewCar"
                  variant="primary"
                  class="mr-1"
                  >Add</b-button
                >
                <b-button type="reset" variant="light">Cancel</b-button>
              </div>
            </form>
          </div>
          <div class="card">
            <div class="card-header"><h5>Do you know that?</h5></div>
            <div class="card-body"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selected: null,
      formStatus: false,
      options: [
        { value: null, text: "Please select driving system" },
        { value: "3Z", text: "3 shifts system" },
        { value: "2Z", text: "2 shifts system" },
        { value: "SOLO", text: "Solo shift system" },
      ],
      formData: {
        regPlate: "",
        owner: "",
        make: "",
        model: "",
        insuranceCompany: "",
        insuranceNumber: "",
        insuranceExpiry: "",
        maitenanceDate: "",
        mileage: "",
        color: '',
        currentSystem: "",
        notAvailable: false, 
        vin: null,
        engineSize: null,
        regDocNumber: null,
      },
      colors: ['White', 'Black', "Blue", "Red", "Silver"]
    };
  },
  methods: {
    async addNewCar() {
      const self = this
      try {
        await this.$store.dispatch("cars/addNewCar", this.formData);
      } catch (error) {
        this.formStatus = true;
        this.basic_success_alert(
          "Something went wrong",
          "There is a problem with adding new car - please try again later"
        );
      }
      if(!this.formStatus){
          this.basic_success_alert('Car added!', 'The car was added successfully.');
          Object.keys(this.formData).forEach(function(key, index) {
              self.formData[key]= '';
          })
      }
    },
    basic_success_alert: function(title, text) {
      this.$swal({
        title: title,
        text: text,
        type: "info",
      });
    },
  },
  computed: {

  },
};
</script>
